import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { horizontalBar } from "./_commonSharedChartOptions";
import _ from "lodash";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";

import { connect } from "react-redux";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";

const data = {
  chart_data: {
    labels: [
      "Jack Tuhtan",
      "Josip Bosnjakovic",
      "Boris Knezevic",
      "Ev Developers",
      "Edvin Mocibob",
      "Mateo Premus",
      "Marin Kruzic",
      "Nea Dujmic"
    ],
    datasets: [
      {
        label: "Voice",
        data: [5, 9, 21, 45, 17, null, null, null],
        backgroundColor: "#FF6384"
      },
      {
        label: "Bubble",
        data: [74, 56, 39, 2, 5, 12, null, 7],
        backgroundColor: "#23b9ff"
      },
      {
        label: "Text",
        data: [105, 57, 34, 64, 5, null, 50, 4],
        backgroundColor: "#b1ff1f"
      }
    ]
  }
};

const config_default = {
  alexa: {
    name: "Alexa",
    data: data,
    Chart: "INTERACTION_ALEXA_USER",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  },
  portal: {
    name: "Portal",
    data: data,
    Chart: "LEX_VOICE_TEXT_INPUT_AT_USER_LEVEL",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  },
  mobile: {
    name: "Mobile",
    data: data,
    Chart: "LEX_VOICE_TEXT_INPUT_AT_USER_LEVEL_MOBILE",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  }
};

const widgetDetails = {
  alexa: {
    Chart: "INTERACTION_ALEXA_USER_DETAILS",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  },
  portal: {
    Chart: "LEX_VOICE_TEXT_INPUT_AT_USER_LEVEL_DETAILS",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  },
  mobile: {
    Chart: "LEX_VOICE_TEXT_INPUT_MOBILE_AT_USER_LEVEL_DETAILS",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  }
};

class UserInteractionContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  setWidgetDataColor(data) {
    data.map(item => {
      item.backgroundColor = setColor(item.label);
    });
    return data;
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">User Interaction </div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <HorizontalBar
              id="user_interaction"
              data={{
                labels: widgetData.labels,
                datasets: this.setWidgetDataColor(widgetData.data_dict.Items)
              }}
              options={_.extend({}, horizontalBar, {
                hover: {
                  onHover: function(e) {
                    let point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = "pointer";
                    else e.target.style.cursor = "default";
                  }
                }
              })}
            />
          )}
        </div>
      </div>
    );
  }
}

export const UserInteractionConfig = ({ instanceId, config, onConfigChange }) => {
  const selectionChanged = e => {
    return onConfigChange(instanceId, { platform: e.target.value });
  };

  return (
    <div className="weather-example-config">
      <div className="city">Choose Platform</div>
      <select className="form-control" onChange={selectionChanged} value={_.get(config, "platform", "portal")}>
        {_.keys(config_default).map(code => (
          <option key={code} value={code}>
            {config_default[code].name}
          </option>
        ))}
      </select>
    </div>
  );
};

export const UserInteractionPreview = () => {
  return (
    <div>
      <div className="widgetTitle">User Interaction</div>
      <div className="widgetBody">
        <HorizontalBar
          data={data.chart_data}
          options={_.merge({}, horizontalBar, {
            legend: { display: false },
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontSize: 5
                  }
                }
              ]
            },
            plugins: {
              datalabels: {
                font: {
                  size: 5
                }
              }
            }
          })}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["UserInputType"]
  };
}

export const UserInteractionContent = connect(
  mapStateToProps,
  undefined
)(UserInteractionContentClass);
